var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline/Interface/Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8854 15.4456C12.2351 17.5682 8.35569 17.4011 5.8989 14.9444C3.26287 12.3083 3.26287 8.03445 5.8989 5.39842C8.53494 2.76238 12.8088 2.76238 15.4448 5.39842C17.9016 7.8552 18.0687 11.7346 15.946 14.3849L21.1017 19.5405C21.3946 19.8334 21.3946 20.3083 21.1017 20.6012C20.8088 20.8941 20.3339 20.8941 20.041 20.6012L14.8854 15.4456ZM6.95956 13.8837C4.90931 11.8334 4.90931 8.50933 6.95956 6.45908C9.00982 4.40882 12.3339 4.40882 14.3842 6.45908C16.4329 8.50782 16.4344 11.8286 14.3887 13.8792C14.3872 13.8807 14.3857 13.8822 14.3842 13.8837C14.3827 13.8852 14.3812 13.8867 14.3797 13.8882C12.3291 15.9339 9.00831 15.9324 6.95956 13.8837Z",
    fill: "#0E6AF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBlue);
export default __webpack_public_path__ + "static/media/search_blue.bd90b111389b21338dc2b840999dc66b.svg";
export { ForwardRef as ReactComponent };